module.exports = __webpack_public_path__ + "static/img/17.66bcb83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/17.jpg
// module id = +FX6
// module chunks = 15